import React from "react"
import { FormattedNumber } from "react-intl"

/* taking care of https://github.com/yahoo/react-intl/issues/785 */
const FormattedNumberNoWarning = ({ styleProp, ...props }) => {
  return <FormattedNumber style={styleProp} {...props} />
}

export default FormattedNumberNoWarning
